import { shadow } from './color';
import { Collection, Token } from './types';
import { opacify } from './utils';

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=849-19039&mode=design&t=tZCslkWS49FsAr7k-4
 */
export const elevation = new Collection({
  xs: new Token(`0 1px 2px 0 ${opacify(shadow.value, 0.05)}`, 'elevation-xs'),
  sm: new Token(
    [
      `0 1px 3px 0 ${opacify(shadow.value, 0.1)}`,
      `0 1px 2px 0 ${opacify(shadow.value, 0.06)}`,
    ].join(','),
    'elevation-sm',
  ),
  md: new Token(
    [
      `0 4px 6px -1px ${opacify(shadow.value, 0.08)}`,
      `0 2px 4px -1px ${opacify(shadow.value, 0.06)}`,
    ].join(','),
    'elevation-md',
  ),
  lg: new Token(
    [
      `0 10px 15px -3px ${opacify(shadow.value, 0.08)}`,
      `0 4px 6px -2px ${opacify(shadow.value, 0.05)}`,
    ].join(','),
    'elevation-lg',
  ),
  xl: new Token(
    [
      `0 16px 24px -2px ${opacify(shadow.value, 0.12)}`,
      `0 6px 30px 5px ${opacify(shadow.value, 0.04)}`,
    ].join(','),
    'elevation-xl',
  ),
  '2xl': new Token(
    `0 25px 50px -12px ${opacify(shadow.value, 0.25)}`,
    'elevation-2xl',
  ),
});
